import React from 'react';
import ReactDOM from 'react-dom/client';
import { hydrateRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import RouteAnalytics from './components/RouteAnalytics';

import { transitions, positions, Provider as AlertProvider } from 'react-alert';
import AlertTemplate from './components/AlertTemplate';
import { captureAttribution } from './apiHelper/attribution';

const options = {
  position: positions.BOTTOM_RIGHT,
  timeout: 5000,
  offset: '5px 16px',
  transition: transitions.SCALE,
  zIndex: 1000000
}

const container = document.getElementById('root') as HTMLElement;

// Record the ad source (UTM tags) the visitor landed with before any in-app navigation
// strips the query string. No-op during react-snap prerender (no real URL/session).
if (navigator.userAgent !== 'ReactSnap') captureAttribution();

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <AlertProvider template={AlertTemplate} {...options}>
        <BrowserRouter>
          <RouteAnalytics />
          <App />
        </BrowserRouter>
      </AlertProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap prerenders each route to static HTML at build time; hydrate that
// markup instead of throwing it away. Falls back to a normal render in dev.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

reportWebVitals();
